/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserBackgroundImageContainer_user$ref: FragmentReference;
declare export opaque type UserBackgroundImageContainer_user$fragmentType: UserBackgroundImageContainer_user$ref;
export type UserBackgroundImageContainer_user = {|
  +id: string,
  +backgroundOption: ?string,
  +customImage: ?string,
  +backgroundColor: ?string,
  +backgroundImage: ?{|
    +imageURL: ?string,
    +timestamp: ?string,
  |},
  +$refType: UserBackgroundImageContainer_user$ref,
|};
export type UserBackgroundImageContainer_user$data = UserBackgroundImageContainer_user;
export type UserBackgroundImageContainer_user$key = {
  +$data?: UserBackgroundImageContainer_user$data,
  +$fragmentRefs: UserBackgroundImageContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "UserBackgroundImageContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "backgroundOption",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "customImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "backgroundColor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "backgroundImage",
      "storageKey": null,
      "args": null,
      "concreteType": "BackgroundImage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageURL",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "timestamp",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '145a4f533fcf42c7355d51459702c96d';
module.exports = node;
